import { render, staticRenderFns } from "./BindsListItemRouter.vue?vue&type=template&id=e85bbbfc&"
import script from "./BindsListItemRouter.vue?vue&type=script&lang=js&"
export * from "./BindsListItemRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports